import { render, staticRenderFns } from "./ProjectCell.vue?vue&type=template&id=4016c360&scoped=true&"
import script from "./ProjectCell.vue?vue&type=script&lang=js&"
export * from "./ProjectCell.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCell.vue?vue&type=style&index=0&id=4016c360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4016c360",
  null
  
)

component.options.__file = "ProjectCell.vue"
export default component.exports